import { TextField, TextFieldProps } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { useField } from "react-final-form";

type ColorPickerProps = Omit<TextFieldProps, "type"> & {
  field: string;
  required?: boolean;
  customHelperText?: React.ReactNode;
  cls?: string;
  initialValue?: string;
  validate?: (val: string) => string | undefined;
};

const useStyles = makeStyles((_theme) => ({
  input: {
    background: "white",
    padding: "8px",
    cursor: "pointer",
  },
}));

export const ColorPicker = ({
  field,
  required = false,
  fullWidth = true,
  variant = "outlined",
  id,
  error,
  customHelperText,
  initialValue,
  cls,
  validate,
  onChange,
  ...textFieldProps
}: ColorPickerProps) => {
  const f = useField(field, { initialValue, validate });

  const classes = useStyles();
  const defaultHelperText = required ? null : "Optional";
  const hasError = Boolean(f.meta.touched && f.meta.error) ?? error;
  const helperText = hasError ? f.meta.error : customHelperText ?? defaultHelperText;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    f?.input?.onChange?.(e); // Final Form change handler
    onChange?.(e); // Custom onChange handler
  };

  return (
    <TextField
      id={id || field}
      type="color"
      InputProps={{
        className: classes.input,
      }}
      fullWidth={fullWidth}
      error={hasError}
      margin="normal"
      helperText={helperText}
      variant={variant as any}
      className={cls}
      {...f.input}
      {...textFieldProps}
      onChange={handleChange}
    />
  );
};
